<wuc-drop-trigger position="bottom" balloonHorizontalAlignment="right" [fullWidth]="true">
    <wuc-button type="secondary" [isFullWidth]="true" iconLeft="emergency" iconType="primary">Schademelden</wuc-button>
    <wuc-balloon padding="medium" [hasCloseIcon]="true" minWidth="37rem">
        <div class="report-claim-button__content">
            <div class="h3">Pech onderweg of noodgeval?</div>
            <wuc-link [url]="'tel:' + phoneNumbersEnum.EurocrossURL" target="_blank" iconLeft="call" iconSize="xs">
                {{ phoneNumbersEnum.Eurocross }}
            </wuc-link>
            <hr class="report-claim-button__hr" />
            <div class="h3">Geen nood?</div>
            <wuc-button type="secondary" (click)="navigateToClaim()">Meld schade online</wuc-button>
            <p class="report-claim-button__link">
                <wuc-link type="secondary" url="/schade" iconLeft="right-open" iconSize="xs">
                    Meer weten over schademelden
                </wuc-link>
            </p>
            <p class="report-claim-button__link">
                <wuc-link type="secondary" route="/verzekeringsmap/mijn-schades" iconLeft="right-open" iconSize="xs">
                    Bekijk schadestatus
                </wuc-link>
            </p>
        </div>
    </wuc-balloon>
</wuc-drop-trigger>
